import { clamp } from '../../../../../internal/utils';
import { useControlled } from '../../../../../internal/hooks';
import { asc } from '../../helpers';
import { equals } from 'ramda';
export function useSliderValueState(props) {
  const {
    min,
    max,
    onChange
  } = props;
  const [valueDerived, setValueState] = useControlled({
    controlled: props.value,
    default: props.defaultValue
  });
  const values = (Array.isArray(valueDerived) ? valueDerived : [valueDerived]).slice().sort(asc).map(value => clamp(value, min, max));
  const range = values.length >= 2;
  const changeValue = nextValue => {
    if (equals(valueDerived, nextValue)) {
      return;
    }
    setValueState(nextValue);
    if (onChange) {
      onChange(nextValue);
    }
  };
  return {
    valueDerived: valueDerived,
    changeValue,
    values,
    range
  };
}